import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderOne from '../components/HeaderOne';
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from '../components/FooterOne';
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";

const OrderFailedPage = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const reason = params.get('reason');
    const errorCode = params.get('errorCode');
    const orderId = params.get('orderId');

    // Hata ikonu bileşeni
    const renderErrorIcon = () => {
        return (
            <div className="icon-container mb-16">
                <div
                    className="bg-danger bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ height: "120px", width: "120px" }}
                >
                    <i
                        className="ph ph-x-circle text-danger"
                        style={{ fontSize: "4rem" }}
                    ></i>
                </div>
            </div>
        );
    };

    return (
        <>
            {/* ColorInit */}
            <ColorInit color={false} />

            {/* ScrollToTop */}
            <ScrollToTop smooth color="#299E60" />

            {/* Preloader */}
            <Preloader />

            {/* HeaderOne */}
            <HeaderOne />

            {/* Breadcrumb */}
            <Breadcrumb title={"Sipariş Başarısız"} />

            {/* Order Failed Content */}
            <section className="order-failed py-60">
                <div className="container container-lg">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="payment-page-card">
                                <div className="card-body p-24">
                                    <div className="text-center">
                                        {renderErrorIcon()}

                                        <h3 className="fw-bold mb-16 text-heading">
                                            Siparişiniz Başarısız
                                        </h3>

                                        <div className="alert alert-danger rounded-16 mb-24">
                                            <div className="d-flex">
                                                <i className="ph ph-warning me-12 mt-10 fs-4"></i>
                                                <div>
                                                    <h5 className="mb-8 fw-semibold">Ödeme işlemi başarısız oldu</h5>
                                                    {orderId && <p className="mb-4" style={{ textAlign: "left" }}><strong>Sipariş No:</strong> {orderId}</p>}
                                                    {reason && <p className="mb-4" style={{ textAlign: "left" }}><strong>Hata Mesajı:</strong> {decodeURIComponent(reason)}</p>}
                                                    {errorCode && <p className="mb-0" style={{ textAlign: "left" }}><strong>Hata Kodu:</strong> {errorCode}</p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="payment-info mb-24">
                                            <div className="alert bg-main-50 p-24 rounded-16 mb-0 border-0">
                                                <div className="d-flex align-items-center">
                                                    <i className="ph ph-info me-12 text-main-600 fs-4"></i>
                                                    <p className="mb-0 text-heading">
                                                        Lütfen daha sonra tekrar deneyin veya Whatsapp ile iletişime geçin.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="next-steps mt-32">
                                            <div className="d-grid gap-16 d-md-flex justify-content-md-center">
                                                <Link
                                                    to="/"
                                                    className="btn btn-lg payment-submit-btn px-24 py-12 rounded-8"
                                                >
                                                    <i className="ph ph-house-line me-8"></i>
                                                    Ana Sayfaya Dön
                                                </Link>
                                                <Link
                                                    to="/cart"
                                                    className="btn btn-lg btn-outline-primary payment-alt-btn px-24 py-12 rounded-8"
                                                >
                                                    <i className="ph ph-shopping-cart me-8"></i>
                                                    Sepete Geri Dön
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ShippingOne */}
            <ShippingOne />

            {/* FooterOne */}
            <FooterOne />

            {/* BottomFooter */}
            <BottomFooter />
        </>
    );
};

export default OrderFailedPage; 